
import Error from "@/components/App/Error.vue";

export default {
  name: "ErrorView",
  components: { Error }
};
